import { useHistory, useLocation } from "react-router-dom";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { usePaymentInstructions } from "../../../PaymentInstructionsContext";
import { addBeneficiaryContainer, addBeneficiaryText } from "../styles_vanilla.css";

export const AddBeneficiary = () => {
  const { readonly, paymentAccountId, caseType } = usePaymentInstructions();

  const history = useHistory();

  const location = useLocation();

  const handleAddBeneficiary = () => {
    if (paymentAccountId) {
      if (caseType === ComplianceCaseTypeEnum.PaymentInstructionChangeReview) {
        history.push(`${location.pathname}/add-full-screen/${paymentAccountId}`);
        return;
      }
      history.push(`${location.pathname}/add/${paymentAccountId}`);
    } else {
      history.push(`${location.pathname}/create`);
    }
  };

  return (
    <Flex
      flexDirection="row"
      gap={Sizes.SM}
      className={readonly ? addBeneficiaryContainer.disabled : addBeneficiaryContainer.enabled}
      onClick={readonly ? undefined : handleAddBeneficiary}
    >
      <Icon type="plus" color={Colors.Primary600} />
      <Text className={addBeneficiaryText}>Add payment beneficiary</Text>
    </Flex>
  );
};
